import { EnvironmentType } from '../schema/environment.enum';

export const TECHNICAL_SUPPORT_COLLECTION: Record<EnvironmentType, string> = {
  [EnvironmentType.DEV]: 'technicalSupportTest',
  [EnvironmentType.TEST]: 'technicalSupportTest',
  [EnvironmentType.LOCAL]: 'technicalSupportTest',
  [EnvironmentType.STAGING]: 'technicalSupportTest',
  [EnvironmentType.UAT]: 'technicalSupportTest',
  [EnvironmentType.LIVE]: 'technicalSupport',
  [EnvironmentType.PRODUCTION]: 'technicalSupport',
  [EnvironmentType.IN_MEMORY]: 'technicalSupportTest',
  [EnvironmentType.RE_DESIGN]: 'technicalSupportTest'
};